/**
 * @generated SignedSource<<559d5fc02c0949dd8c6fd11c32e49e4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BrandMessageStatusEnum = "A" | "S" | "%future added value";
export type ChatBubbleTypeEnum = "CAROUSEL_COMMERCE" | "CAROUSEL_FEED" | "COMMERCE" | "IMAGE" | "PREMIUM_VIDEO" | "TEXT" | "WIDE" | "WIDE_ITEM_LIST" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly chatBubbleType: ChatBubbleTypeEnum;
      readonly createTime: any;
      readonly id: string;
      readonly serviceStatus: BrandMessageStatusEnum;
      readonly templateCode: string;
      readonly templateName: string;
    };
  }>;
  readonly " $fragmentType": "BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection";
};
export type BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection$key = {
  readonly " $data"?: BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandMessageTemplateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandMessageTemplate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "chatBubbleType",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandMessageTemplateConnection",
  "abstractKey": null
};

(node as any).hash = "ced3439e9b00afb2b08310ef34ea8eeb";

export default node;
